module.exports = __webpack_public_path__ + "static/media/luton-realistic.dd626e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vans/luton-realistic.png
// module id = 885
// module chunks = 0